import { useFormSubmission } from '../../contexts/form-submission-context';
import { CheckCircle2, ExternalLink } from 'lucide-react';
import { cn } from '@shondalai/ui-commons';
import { Button, useLanguage } from '@shondalai/ui-commons';

export function FormSuccessMessage() {
  const { submissionResponse, form } = useFormSubmission();
  const { t } = useLanguage();

  if (!submissionResponse) return null;

  return (
    <div className={cn(
      "mx-auto text-center space-y-5",
      "p-8 md:p-10 rounded-lg border border-primary/20 bg-primary/5"
    )}>
      {/* Success Icon */}
      <div className="flex justify-center">
        <div className={cn(
          "w-14 h-14 rounded-full flex items-center justify-center",
          "!bg-primary !text-primary-foreground shadow-sm"
        )}>
          <CheckCircle2 className="w-7 h-7" strokeWidth={1.5} />
        </div>
      </div>

      {/* Success Title */}
      <h2 className="text-2xl md:text-3xl font-semibold text-foreground tracking-tight">
        {form?.formType === 'quiz' ? t('COM_EASYFORMS_QUIZ_COMPLETED', 'Quiz Completed!') : t('COM_EASYFORMS_THANK_YOU', 'Thank You!')}
      </h2>

      {/* Success Message */}
      <p className="text-sm text-muted-foreground font-light leading-relaxed">
        {submissionResponse.message || t('COM_EASYFORMS_RESPONSE_SUBMITTED', 'Your response has been successfully submitted.')}
      </p>

      {/* Quiz Score (if applicable) */}
      {submissionResponse.score !== undefined && (
        <div className="py-3">
          <div className="text-4xl font-semibold text-foreground">
            {submissionResponse.score} / {submissionResponse.maxScore}
          </div>
          <p className="text-xs text-muted-foreground/70 font-light mt-1.5">
            {submissionResponse.percentage}% {t('COM_EASYFORMS_SCORE', 'Score')}
          </p>
          {submissionResponse.grade && (
            <div className="mt-3">
              <span className={cn(
                "inline-flex items-center px-3 py-1 rounded text-xs font-medium",
                "bg-primary/15 text-primary border border-primary/20"
              )}>
                {t('COM_EASYFORMS_GRADE', 'Grade')}: {submissionResponse.grade}
              </span>
            </div>
          )}
        </div>
      )}

      {/* Submission ID */}
      <p className="text-[11px] text-muted-foreground/60 font-light">
        {t('COM_EASYFORMS_SUBMISSION_ID', 'Submission ID')}: #{submissionResponse.submissionId}
      </p>

      {/* Redirect Link */}
      {submissionResponse.redirectUrl && (
        <div className="pt-3">
          <Button
            onClick={() => {
              if (submissionResponse.redirectUrl) {
                window.location.href = submissionResponse.redirectUrl;
              }
            }}
            className="gap-2 h-9 shadow-sm"
          >
            {t('COM_EASYFORMS_CONTINUE', 'Continue')}
            <ExternalLink className="w-3.5 h-3.5" strokeWidth={1.5} />
          </Button>
          <p className="text-xs text-muted-foreground/70 font-light mt-2">
            {t('COM_EASYFORMS_REDIRECTING_AUTOMATICALLY', 'Redirecting automatically...')}
          </p>
        </div>
      )}
    </div>
  );
}
